export const BUDGETSTATUS = {
  converted: Number(process.env.REACT_APP_BUDGET_CONVERTED),
  canceled: Number(process.env.REACT_APP_BUDGET_CANCELED),
};
